/* unplugin-vue-components disabled */import { render } from "./merge-modal.vue?vue&type=template&id=7fbaabb0&scoped=true"
import script from "./merge-modal.vue?vue&type=script&lang=js"
export * from "./merge-modal.vue?vue&type=script&lang=js"

import "./merge-modal.vue?vue&type=style&index=0&id=7fbaabb0&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbaabb0"],['__file',"src/pages/sh-companies/merge-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fbaabb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fbaabb0', __exports__)) {
    api.reload('7fbaabb0', __exports__)
  }
  
  module.hot.accept("./merge-modal.vue?vue&type=template&id=7fbaabb0&scoped=true", () => {
    api.rerender('7fbaabb0', render)
  })

}


export default __exports__